module.exports = __webpack_public_path__ + "static/media/cross.46e52053.svg";